import {Pipe, PipeTransform} from "@angular/core";
import {GebaeudeArt} from "../../../core/gb-api";
import {TranslateService} from "@ngx-translate/core";
import {translateName} from "../../functions/language.functions";
import {log} from "../../../log/log";

@Pipe({
  name: 'formatGebaeudeart'
})
export class FormatGebaeudeArtPipe implements PipeTransform {
  transform(value: GebaeudeArt, translateService: TranslateService): any {
    let art = '';
    if (value && value.code) {
      const translatedArt = translateName(value.code.text, translateService);
      if (translatedArt) {
        art = translatedArt;
      } else {
        log.info("Could not translate Gebäude-Art Code " + value.code);
      }
    }
    return [art, value.zusatz].filter(val => val).join(' ');
  }

}
